export const validatorPositive = value => {
  if (value >= 0) {
    return true
  }
  return false
}

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrlValidator = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorDecimal = (value, args = {}) => {
  if (value === null || value === undefined || value === '') {
    return true
  }
  if (Array.isArray(value)) {
    return value.every(val => validatorDecimal(val, args))
  }
  const decimals = Array.isArray(args) ? args[0] : (args?.decimals ?? args?.[0] ?? '*')
  const regexPart = decimals === '*' || decimals === undefined || decimals === null ? '*' : `{0,${decimals}}`
  const regex = new RegExp(`^[-+]?\\d*(\\.\\d${regexPart})?$`)
  const strVal = String(value).trim()
  if (strVal === '' || strVal === '.' || strVal === '-' || strVal === '+') return false
  return regex.test(strVal)
}

